// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8f8b6fc","732":"38bd9b99"}[chunkId] + ".chunk.js";
};